import SimpleFormModal, {
  SimpleFormModalRef,
  ExtendedProFormColumnsType,
} from '@/components/SimpleFormModal';
import { editEmployee } from '@/services/common';
import { Button, message, Tooltip } from 'antd';
import { useEffect, useRef } from 'react';
import { useModel } from '@umijs/max';
import { QuestionCircleOutlined } from '@ant-design/icons';

const Index = () => {
  const { initialState } = useModel('@@initialState');
  const simpleFormModalRef = useRef<SimpleFormModalRef>(null);
  const formColumns: ExtendedProFormColumnsType[] = [
    {
      title: '手机号',
      dataIndex: 'phone',
      width: 200,
      formItemProps: {
        validateFirst: true,
        rules: [
          { required: true, whitespace: true },
          {
            validator(rule, value) {
              if (value?.length !== 11) {
                return Promise.reject(new Error('请输入正确的手机号'));
              }
              return Promise.resolve();
            },
          },
        ],
      },
    },
  ];
  useEffect(() => {
    // 这里可以根据实际需求判断是否需要弹出绑定手机号的弹窗
    if (!initialState?.userInfo?.phone) {
      simpleFormModalRef.current?.open(
        <div>
          请先绑定手机号
          <Tooltip title={`绑定后手机号后，您可以使用手机号登录系统，方便快捷。初始密码：7777777`}>
            <QuestionCircleOutlined style={{ color: '#999', marginLeft: 10, cursor: 'pointer' }} />
          </Tooltip>
        </div>,
        {
          async onFinish(values) {
            const res = await editEmployee(initialState?.userInfo?.id, values);
            if (res.code === 200) {
              message.success('绑定成功');
              return true;
            }
            return false;
          },
        },
      );
    }
  }, [initialState]);
  return (
    <>
      <SimpleFormModal
        ref={simpleFormModalRef}
        columns={formColumns}
        modalProps={{
          closable: false,
          centered: true,
        }}
        submitter={{
          render: (props) => {
            return [
              <Button
                type="primary"
                key="ok"
                onClick={() => {
                  props.submit();
                }}
              >
                提交
              </Button>,
            ];
          },
        }}
      />
    </>
  );
};

export default Index;
